import styles from './StickOrRock.module.css';

const stickOrRock = [
  '/rock.jpg',
  '/rock.jpg',
  '/rock.jpg',
  '/stick.jpg',
  '/stick.jpg',
  '/stick.jpg'
]

export const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}



export const StickOrRock = () => {

  const randomSelection = getRandomInt(0, stickOrRock.length - 1);


  return (<div className={styles.wrapper}>
    {randomSelection === 1
      ? <img alt="rock" src="https://upload.wikimedia.org/wikipedia/commons/1/11/Dwayne_%22The_Rock%22_Johnson_Visits_the_Pentagon_%2841%29_%28cropped%29.jpg" />
      : <img alt={randomSelection > 2 ? "stick" : "rock"} src={stickOrRock[randomSelection]} />}
  </div>)
}